module.exports = __webpack_public_path__ + "static/media/biaacc5.eb97228a.jpg";